// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Overlay_overlay_3359M","overlay--open":"Overlay_overlay--open_3t1gz","container":"Overlay_container_6mmGY","content":"Overlay_content_Z24KN","mobileOverlay":"Overlay_mobileOverlay_2OJKY","close":"Overlay_close_3hYeN"};
    if(module.hot) {
      // 1789136764475
      var cssReload = require("/drone/src/node_modules/@vue/cli-service/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":true});
      module.hot.dispose(cssReload);
      
    }
  